import { SICK_DAY_REASONS_TO_NEW_SUBTYPE } from '../../../shared/leave/constants';
import {
  CreateLeaveCommand,
  LeaveDto,
  LeaveDtoWithCompensation,
  LeaveFormData,
  LeaveSubType,
  LeaveType,
  UpdateLeaveCommand,
} from 'domain/shared/leave';

export const mapLeaveDtoToFormLeaveData = (leave: LeaveDto | LeaveDtoWithCompensation): LeaveFormData => ({
  employeeAlias: leave.employeeAlias,
  type: leave.type,
  subType: leave.subType || (leave.sickDayReason && SICK_DAY_REASONS_TO_NEW_SUBTYPE[leave.sickDayReason]) || null,
  status: leave.status,
  sickDayReason: leave.sickDayReason,
  startDate: leave.period.startDate,
  endDate: leave.period.plannedEndDate,
  extendedEndDate: leave.period.extendedEndDate || null,
  allowedExtensionDate: leave.period.allowedExtensionDate || null,
  isManagedByProcess: leave.processInfo.isManagedByProcess,
  applicationScansIds: leave.artifactIds,
  signatureOption: leave.signatureOption.option,
  electronicOptionReason: leave.signatureOption.electronicOptionReason,
  electronicOptionAgreement: leave.signatureOption.electronicOptionAgreement,
  isIgnoreNotStrictRules: leave.rulesViolationInfo.notStrictRulesIgnored,
  rulesViolationReason: leave.rulesViolationInfo.rulesViolationReason,
  comment: leave.rulesViolationInfo.comment,
});

const commandType = (leave: LeaveFormData): LeaveType =>
  leave.type === 'COMPENSATION' ? 'PAID_LEAVE' : (leave.type as LeaveType);

const commandSubType = (leave: LeaveFormData): LeaveSubType | null => {
  const fromReason = leave.sickDayReason && SICK_DAY_REASONS_TO_NEW_SUBTYPE[leave.sickDayReason];
  const sub = leave.subType || fromReason || null;
  if (leave.type === 'COMPENSATION' && !sub) {
    return 'COMPENSATION';
  }
  return sub;
};

const mapLeaveFormDataToLeaveCommandBase = (leave: LeaveFormData) => ({
  type: commandType(leave),
  subType: commandSubType(leave),
  status: leave.status,
  sickDayReason: leave.sickDayReason,
  startDate: leave.startDate,
  endDate: leave.endDate,
  extendedEndDate: leave.extendedEndDate || null,
  isManagedByProcess: leave.isManagedByProcess,
  applicationScansIds: leave.applicationScansIds || [],
  signatureOption: leave.signatureOption,
  electronicOptionReason: leave.electronicOptionReason,
  electronicOptionAgreement: leave.electronicOptionAgreement,
  isIgnoreNotStrictRules: leave.isIgnoreNotStrictRules,
  rulesViolationReason: leave.rulesViolationReason,
  comment: leave.comment,
});

export const mapLeaveFormDataToCreateLeaveCommand = (leave: LeaveFormData): CreateLeaveCommand => ({
  employeeAlias: leave.employeeAlias,
  ...mapLeaveFormDataToLeaveCommandBase(leave),
});

export const mapLeaveFormDataToUpdateLeaveCommand = (leave: LeaveFormData): UpdateLeaveCommand => ({
  ...mapLeaveFormDataToLeaveCommandBase(leave),
  payoutOption: null,
});
